

















































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositOverdraftInterestSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositOverdraftInterestSettingsRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ListUtils from '@/lib/listUtils';
import InterestRateType from '@/models/Products/InterestRateType';
import PeriodType from '@/models/Shared/PeriodType';
import CurrencyUtils from '@/lib/currencyUtils';

@Component({ name: 'AccountDepositOverdraftInterestSettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    request: UpdateAccountDepositOverdraftInterestSettingsRequest = new UpdateAccountDepositOverdraftInterestSettingsRequest(null, null);

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositOverdraftInterestSettingsRequest(DepositAccountSettingsModule.settings.depositOverdraftInterestSettings, new Date());
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositOverdraftInterestSettings;
    }

    get productIssue() {
        return DepositAccountSettingsModule.productIssue;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get rateSourceOptions() {
        return DepositAccountSettingsModule.rateSources;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            this.request.interestBearingThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.interestBearingThreshold.amount);
            this.request.rateValue = +this.request.rateValue;

            // If rate type is fixed then clear out any previosuly selected info for a variable rate type
            if (this.request.rateType === InterestRateType.Fixed) {
                this.request.rateSourceId = undefined;
            }

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            await DepositAccountSettingsModule.editDepositOverdraftInterestSettings(this.request);
        }
    }

}
